import React, { useEffect, useState } from 'react';

const TimerDisplay = ({ isRunning, startTime, initialSeconds }) => {
    const [secondsElapsed, setSecondsElapsed] = useState(initialSeconds);

    useEffect(() => {
        let interval = null;

        const computeTime = () => {
            if (isRunning && startTime) {
                const now = Date.now();
                const liveElapsed = Math.floor((now - startTime) / 1000);
                setSecondsElapsed(initialSeconds + liveElapsed);
            } else {
                // Not running, just show previous saved time
                setSecondsElapsed(initialSeconds);
            }
        };

        computeTime();
        if (isRunning && startTime) {
            interval = setInterval(() => {
                computeTime();
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [isRunning, startTime, initialSeconds]);

    const formatTime = (secs) => {
        const minutes = String(Math.floor(secs / 60)).padStart(2, '0');
        const seconds = String(secs % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    if (secondsElapsed === null) {
        return <span className="text-muted">...</span>;
    }

    return <span>{formatTime(secondsElapsed)}</span>;
};

export default React.memo(TimerDisplay);
